import { ReactComponent as GlobalIcon } from '../../../../assets/Globe.svg';

export const SideBarData = [
  {
    link: '/questions',
    icon: <GlobalIcon className='icon' />,
    text: 'Questions',
  },
  {
    link: '/tags',
    text: 'Tags',
  },
  {
    link: '/users',
    text: 'Users',
  },
  {
    link: '/jobs',
    text: 'Jobs',
  }
]